<section class="section pt-0" *ngIf="registers?.length">
    <div class="container">
        <nb-tabset (changeTab)="onTabChange($event)">
            <h3 class="heading" ngProjectAs="nb-tab">{{ "HOME.CHAMPIONS-RANKING" | translate }}</h3>
            <nb-tab *ngFor="let tab of registers; let index = index" [tabTitle]="tab.title" [active]="index === 0">
                <ngx-glide
                    [perView]="4"
                    [showBullets]="false"
                    [arrowLeftTemplate]="arrowLeft"
                    [arrowRightTemplate]="arrowRight"
                    [breakpoints]="breakpoints"
                    #ngxGlide
                >
                    <div
                        class="champion"
                        [class.vip]="champion.vip"
                        *ngFor="let champion of tab.list"
                        [style.background-image]="'url(' + champion.url_avatar + ')'"
                    >
                        <div class="champion-info">
                            <nb-icon class="champion-vip-icon mb-1" icon="star" *ngIf="champion.vip"></nb-icon>
                            <p class="champion-location">{{ champion.cidade }} / {{ champion.uf }}</p>
                            <h4 class="champion-name">{{ champion.nome_abreviado }}</h4>
                            <p class="champion-awards">
                                <nb-icon icon="award-outline" class="mr-2"></nb-icon><span>{{ champion.total }}</span>
                            </p>
                        </div>
                    </div>
                </ngx-glide>
            </nb-tab>
        </nb-tabset>
    </div>
</section>

<ng-template #arrowLeft>
    <button nbButton class="slide-arrow slide-arrow--left"><nb-icon icon="arrow-ios-back-outline"></nb-icon></button>
</ng-template>
<ng-template #arrowRight>
    <button nbButton class="slide-arrow slide-arrow--right">
        <nb-icon icon="arrow-ios-forward-outline"></nb-icon>
    </button>
</ng-template>
